import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import Icon from './Icon.js';
import UbicacionSelector from './UbicacionSelector.jsx';
import { MP_SURF } from '../constants/surfaces.js';

export function MarketplaceSearchSections({
  busqueda,
  onBusquedaChange,
  distanciaKmFiltro,
  userLat,
  userLng,
  loadingGeo,
  geoNearbyError,
  onActivarFiltroDistancia,
  onDesactivarFiltroDistancia,
  onDistanciaKmChange,
  ubicacionProvincia,
  ubicacionMunicipio,
  onUbicacionProvinciaChange,
  onUbicacionMunicipioChange,
  goldColor,
  inputStyle,
}) {
  return (
    <>
      <div style={{ marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${MP_SURF.divider}` }}>
        <div style={{ fontSize:'0.68rem', fontWeight:700, color:MP_SURF.labelMuted, textTransform:'uppercase', letterSpacing:'0.09em', marginBottom:8 }}>
          Búsqueda general
        </div>
        <div style={{ position:'relative' }}>
          <svg style={{ position:'absolute', left:9, top:'50%', transform:'translateY(-50%)', color:'#bbb' }} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
          <input value={busqueda} onChange={e=>onBusquedaChange(e.target.value)}
            placeholder="Artista, disco, sello, año, vendedor, ciudad…"
            style={{ ...inputStyle, paddingLeft:27 }}
            onFocus={e=>e.target.style.borderColor=goldColor}
            onBlur={e=>e.target.style.borderColor=MP_SURF.inputBorder}/>
        </div>
      </div>

      <div style={{ marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${MP_SURF.divider}` }}>
        <div style={{ fontSize:'0.68rem', fontWeight:700, color:MP_SURF.labelMuted, textTransform:'uppercase', letterSpacing:'0.09em', marginBottom:8 }}>
          Cerca de mí
        </div>
        {distanciaKmFiltro == null || userLat == null || userLng == null ? (
          <button
            type="button"
            onClick={onActivarFiltroDistancia}
            disabled={loadingGeo}
            style={{
              width: '100%',
              padding: '8px 12px',
              borderRadius: 8,
              border: `1px dashed ${loadingGeo ? MP_SURF.chipInactiveBorder : `rgba(200,168,75,0.45)`}`,
              background: 'rgba(200,168,75,0.08)',
              color: loadingGeo ? MP_SURF.textDim : C.gold,
              fontSize: '0.76rem',
              fontWeight: 600,
              cursor: loadingGeo ? 'wait' : 'pointer',
              fontFamily: 'inherit',
            }}
          >
            {loadingGeo ? 'Obteniendo ubicación…' : 'Usar mi ubicación'}
          </button>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ fontSize: '0.74rem', fontWeight: 700, color: C.gold }}>Radio</span>
              <button
                type="button"
                onClick={onDesactivarFiltroDistancia}
                style={{ fontSize: '0.68rem', color: '#999', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}
              >
                Quitar
              </button>
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {[5, 15, 30, 50, 100].map(km => (
                <button
                  key={km}
                  type="button"
                  onClick={() => onDistanciaKmChange(km)}
                  style={{
                    padding: '5px 10px',
                    borderRadius: 6,
                    fontSize: '0.72rem',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    border: `1px solid ${distanciaKmFiltro === km ? goldColor : MP_SURF.chipInactiveBorder}`,
                    background: distanciaKmFiltro === km ? MP_SURF.chipActiveBg : MP_SURF.chipInactiveBg,
                    color: distanciaKmFiltro === km ? C.gold : MP_SURF.chipInactiveColor,
                  }}
                >
                  {km} km
                </button>
              ))}
            </div>
          </>
        )}
        {geoNearbyError ? (
          <div style={{ marginTop: 8, fontSize: '0.7rem', color: '#b91c1c', lineHeight: 1.35 }}>{geoNearbyError}</div>
        ) : (
          distanciaKmFiltro != null &&
          userLat != null &&
          userLng != null && (
            <div style={{ marginTop: 8, fontSize: '0.62rem', color: MP_SURF.textDim, lineHeight: 1.35 }}>
              Solo anuncios con coordenadas (publicados tras geocodificar). Los demás no se muestran.
            </div>
          )
        )}
      </div>

      <div style={{ marginBottom:14, paddingBottom:14, borderBottom:`1px solid ${MP_SURF.divider}` }}>
        <div style={{ fontSize:'0.68rem', fontWeight:700, color:MP_SURF.labelMuted, textTransform:'uppercase', letterSpacing:'0.09em', marginBottom:8 }}>
          Ubicación (España)
        </div>
        <UbicacionSelector
          variant="dark"
          spacing={10}
          soloEspana
          provincia={ubicacionProvincia}
          municipio={ubicacionMunicipio}
          onProvinciaChange={onUbicacionProvinciaChange}
          onMunicipioChange={onUbicacionMunicipioChange}
        />
      </div>
    </>
  );
}

export function MarketplaceResultsToolbar({
  total,
  totalPages,
  currentPage,
  generosSel,
  onRemoveGenero,
  vista,
  onVistaChange,
  ordenar,
  onOrdenarChange,
  sortOptions,
  goldColor,
  /** Mercado: abre el panel lateral de filtros. Si es `null`, no se muestra la lupa. */
  onToggleFilters = null,
  filtersOpen = false,
  filterCount = 0,
  /** Mercado: atajos que fijan orden "novedades" / "recomendaciones". Si ambos son `null`, se muestra el `<select>` de ordenación. */
  onFeedNovedades = null,
  onFeedRecomendaciones = null,
}) {
  const showFeedShortcuts = typeof onFeedNovedades === 'function' && typeof onFeedRecomendaciones === 'function';
  const feedBtn = (active, label, title, onClick) => (
    <button
      type="button"
      title={title}
      onClick={onClick}
      style={{
        padding: '6px 11px',
        borderRadius: 7,
        border: active ? `1px solid ${goldColor}` : `1px solid ${MP_SURF.chipInactiveBorder}`,
        background: active ? MP_SURF.chipActiveBg : MP_SURF.chipInactiveBg,
        color: active ? C.gold : MP_SURF.chipInactiveColor,
        fontSize: '0.72rem',
        fontWeight: active ? 800 : 600,
        cursor: 'pointer',
        fontFamily: 'inherit',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 13, flexWrap: 'wrap' }}>
      {typeof onToggleFilters === 'function' ? (
        <button
          type="button"
          data-guest-safe
          title="Buscar y filtros"
          aria-expanded={filtersOpen}
          aria-label={filtersOpen ? 'Cerrar filtros' : 'Abrir búsqueda y filtros'}
          onClick={() => onToggleFilters()}
          style={{
            position: 'relative',
            width: 38,
            height: 38,
            borderRadius: '50%',
            border: `1px solid ${filtersOpen ? goldColor : 'rgba(200,168,75,0.28)'}`,
            background: filtersOpen ? 'rgba(200,168,75,0.18)' : 'rgba(200,168,75,0.06)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            flexShrink: 0,
            transition: 'background 0.15s ease, border-color 0.15s ease',
          }}
        >
          <Icon name="search" size={16} color={filtersOpen ? C.gold : goldColor} />
          {filterCount > 0 ? (
            <span
              style={{
                position: 'absolute',
                top: -2,
                right: -2,
                minWidth: 16,
                height: 16,
                padding: '0 4px',
                borderRadius: 8,
                background: goldColor,
                color: '#0a0a0f',
                fontSize: 9,
                fontWeight: 800,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1.5px solid #fff',
              }}
            >
              {filterCount > 9 ? '9+' : filterCount}
            </span>
          ) : null}
        </button>
      ) : null}

      <span style={{ fontSize: '0.8rem', color: MP_SURF.textMuted }}>
        <strong style={{ color: MP_SURF.text }}>{total}</strong> encontrados
        {totalPages > 1 && (
          <span style={{ color: MP_SURF.textDim, fontWeight: 400 }}> · Página {currentPage} de {totalPages}</span>
        )}
      </span>

      {generosSel.map(g => (
        <span
          key={g}
          onClick={() => onRemoveGenero(g)}
          style={{
            background: 'rgba(200,168,75,0.09)',
            border: '1px solid rgba(200,168,75,0.22)',
            color: C.gold,
            padding: '3px 8px',
            borderRadius: 9,
            fontSize: '0.7rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {g} ×
        </span>
      ))}

      <div style={{ flex: 1, minWidth: 8 }} />

      <div style={{ display: 'flex', gap: 2, background: 'rgba(255,255,255,0.06)', borderRadius: 6, padding: 2 }}>
        {[
          { v: 1, i: '☰' },
          { v: 4, i: '⊞' },
        ].map(({ v, i }) => (
          <button
            key={v}
            type="button"
            onClick={() => onVistaChange(v)}
            style={{
              width: 27,
              height: 27,
              borderRadius: 4,
              border: 'none',
              background: vista === v ? MP_SURF.card : 'transparent',
              boxShadow: vista === v ? '0 1px 3px rgba(0,0,0,0.35)' : 'none',
              cursor: 'pointer',
              fontSize: '0.82rem',
              color: vista === v ? goldColor : MP_SURF.textDim,
              transition: 'all .13s',
            }}
          >
            {i}
          </button>
        ))}
      </div>

      {showFeedShortcuts ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          {feedBtn(
            ordenar === 'recientes',
            'Novedades',
            'Últimos discos añadidos',
            onFeedNovedades
          )}
          {feedBtn(
            ordenar === 'recomendaciones',
            'Recomendaciones',
            'Prioriza anuncios de partners (en el futuro: impulsos con Grooves)',
            onFeedRecomendaciones
          )}
        </div>
      ) : (
        <select
          value={ordenar}
          onChange={e => onOrdenarChange(e.target.value)}
          style={{
            padding: '6px 10px',
            border: MP_SURF.inputBorder,
            borderRadius: 6,
            fontSize: '0.76rem',
            background: MP_SURF.inputBg,
            outline: 'none',
            color: MP_SURF.text,
            cursor: 'pointer',
          }}
        >
          {sortOptions.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
